// B1 (role-aware landing): explicit per-operator map from identity → the surface
// that operator actually works. This is deliberately an EXPLICIT map, never a
// heuristic over department/role — `role` is only 'admin'|'member' and
// `department` collides (Vince+Ron are both Operations; Nate+Randy are both
// Production), so inferring a home would mis-route. Per the org rule "never
// bulk-populate a human-override layer with a heuristic," each known operator is
// listed by email; everyone else — a technician, a new hire, an unmapped
// account — lands on the neutral `/welcome` orientation card, NEVER Erik's owner
// cockpit. Adding an operator's home is a one-line edit here.
//
// Keyed by the same person→queue model the routes already encode
// (/queues/erik, /queues/vince, /queues/nate, /ron). Mirrors the hardcoded
// roster in apps/sales-qa/src/users.ts (DB-backed roster is deferred — PRD §10 #12).

export const WELCOME_HOME = '/welcome';

const ROLE_HOME_BY_EMAIL: Readonly<Record<string, string>> = {
  'erik.carver@overlanddesignbuild.com': '/queues/erik',
  'vince.e@overlanddesignbuild.com': '/queues/vince',
  'nate.r@overlanddesignbuild.com': '/queues/nate',
  'ron.s@overlanddesignbuild.com': '/ron',
};

/**
 * Resolve where a signed-in operator should land at `/`.
 * Unknown / unmapped accounts fail safe to the neutral `/welcome` card.
 */
export function roleHome(user: { email: string }): string {
  return ROLE_HOME_BY_EMAIL[user.email.trim().toLowerCase()] ?? WELCOME_HOME;
}
